import * as React from "react";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import { useNavigate } from "react-router";
import { auth } from "../../../firebase";
import { signOut } from "firebase/auth";
import { toast } from "react-toastify";
import { useAuth } from "../../hooks/AuthContext";

export default function CustomModal({
  open,
  setOpen,
  title,
  description,
  handleConfirm,
  confirmBtnLaebel,
  cancelBtnLabel,
}) {
  const handleClose = () => {
    setOpen(false);
  };

  return (
    <React.Fragment>
      <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle
          id="alert-dialog-title"
          sx={{
            fontSize: "18px",
            fontWeight: 600,
            color: "var(--neutral-black)",
          }}
        >
          {title}
        </DialogTitle>
        <DialogContent>
          <DialogContentText
            id="alert-dialog-description"
            sx={{
              fontSize: "16px",
              fontWeight: 500,
              color: "var(--neutral-700)",
            }}
          >
            {description}
          </DialogContentText>
          {/* <DialogContentText
            sx={{
              fontSize: "16px",
              fontWeight: 500,
              color: "var(--neutral-700)",
            }}
          >
            You will be redirected to the homepage after logging out.
          </DialogContentText> */}
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose} sx={{ px: 2 }}>
            {cancelBtnLabel}
          </Button>
          <Button
            variant="contained"
            onClick={handleConfirm}
            autoFocus
            sx={{ px: 2 }}
          >
            {confirmBtnLaebel}
          </Button>
        </DialogActions>
      </Dialog>
    </React.Fragment>
  );
}
